export default __webpack_public_path__ + "static/media/Dar_Baixa_de_Arquivo.e588ec72.svg";